import { render, staticRenderFns } from "./ViUpgradePlanPricing.vue?vue&type=template&id=304706c7"
import script from "./ViUpgradePlanPricing.vue?vue&type=script&lang=js"
export * from "./ViUpgradePlanPricing.vue?vue&type=script&lang=js"
import style0 from "./ViUpgradePlanPricing.vue?vue&type=style&index=0&id=304706c7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports